//@import dependencies
import React, { ReactChild } from 'react'
import { useTranslation } from 'react-i18next'

import SvgList from './iconList'
//@end

//@import components
//@end

// @import hooks
// @end

// @INFO Import types
import {IFontawesomeIcon} from 'app_types/components/icon/fontawesomeTypes'
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../iconsCommon.scss'

// @ADD Component types
interface IIconsCommonLayoutProps {
  svg?: string
  fontawesome?: IFontawesomeIcon
  component?: ReactChild
  class_name?: string
  color?: any
  height?: any
  width?: any
  data_tip?: string
  onClick?: () => any
}

const IconsCommonLayout: React.FC<IIconsCommonLayoutProps> = (props) => {
  const { t } = useTranslation()

  const svgRender: any = (props.svg) ? SvgList[props.svg] : null

  return(
    <>
    {props.svg && svgRender && (
      <svg
        data-tip={props.data_tip}
        viewBox={svgRender ? svgRender.viewBox : ''}
        className={props.class_name}
        xmlns='http://www.w3.org/2000/svg'
        style={{ fill: `${props.color}`, height: `${props.height}`, width: `${props.width}` }}
        onClick={props.onClick}
      >
        {svgRender.svg}
      </svg>
    )}
    {props.fontawesome && (
      <>
      {props.fontawesome?.stacking?.icon ? (
        <>
          <span onClick={props.onClick} className={`fa-stack ${(props.fontawesome?.stacking?.size) ? props.fontawesome?.stacking?.size : ''}`}>
            <i className={`${props.fontawesome?.stacking?.icon} fa-stack-2x`} style={{color: `${props.fontawesome?.stacking?.color}`, height: `${props.fontawesome?.stacking?.height}`, width: `${props.fontawesome?.stacking?.width}`}}></i>
            <i className={`${props.fontawesome.icon} fa-stack-1x`} style={{color: `${props.color}`, height: `${props.height}`, width: `${props.width}`}}></i>
          </span>
        </>
      ): (
        <i className={props.fontawesome.icon} style={{color: `${props.color}`, height: `${props.height}`, width: `${props.width}`}}></i>
      )}
      </>
    )}
    {props.component && (props.component)}
    </>
  )
}

export default IconsCommonLayout
